export default "__VITE_ASSET__xhg6A3DK__"